import { create } from "zustand";

type TariffSelectorUiState = {
  isServiceMenuOpen: boolean;
  toggleServiceMenu: () => void;
  closeServiceMenu: () => void;
};

export const useTariffSelectorUiStore = create<TariffSelectorUiState>()(
  (set) => ({
    isServiceMenuOpen: false,
    toggleServiceMenu: () =>
      set((state) => ({ isServiceMenuOpen: !state.isServiceMenuOpen })),
    closeServiceMenu: () => set({ isServiceMenuOpen: false }),
  })
);
